
/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { selectAppLocation } from '../appLocation/appLocationSelector';

export const selectAllUsers = (state: { user: any; }) => state.user.users;
export const selectAllFilteredUsers = (state: { user: any; }) => state.user.filteredUsers;
export const selectSelectedItem = (state: { user: any; }) => state.user.selectedItem;
export const getSelectedItemDetails = (state: { user: any; }) => state.user.selectedItemDetails;
export const getPaginationDetails = (state: { user: any; }) => state.user.page;

export const selectNoItem = (state: { user: any; }) => state.user.noItem;
export const selectSearch = (state: { user: any; }) => state.user.searchValue;
export const selectSearchKey = (state: { user: any; }) => state.user.searchKey;
export const selectPage = (state: { user: any; }) => state.user.page;
export const getAllIdps = (state: { user: any; }) => state.user.idps;
export const getIdpRoles = (state: { user: any; }) => state.user.idpRoles;
export const selectRolesToAssign = (state: { user: any; }) => state.user.rolesToAssign;

export const selectLocationIdpId = (state: any) => {
  const appLocation = selectAppLocation(state);

  if (!appLocation) {
    return undefined;
  }

  const idps: { id: string; idpType: string; idpSchema?: { externalIdentityProviders?: any[] } }[] = getAllIdps(state);

  const nativeIdp = idps.find(idp => idp.idpType === 'Native');
  const idpMap: Record<string, string> = Object.assign({}, ...(nativeIdp?.idpSchema?.externalIdentityProviders ?? []));

  return idpMap[appLocation.id] ?? idpMap['default'];
};
